module.exports = __webpack_public_path__ + "img/logoBest.1db24ddf.png";